import React from 'react';
import { MessageSquare, FileCheck, FileSignature, PackageCheck } from 'lucide-react';

const steps = [
  { Icon: MessageSquare, title: 'Contact & Finalise Quote', desc: 'Free consultation with a compliance specialist. Get a tailored quote and timeline in under 24 hours.' },
  { Icon: FileCheck, title: 'Complete KYC', desc: 'Share PAN, Aadhar and business proof. Our team verifies documents digitally — no visits, no paperwork trips.' },
  { Icon: FileSignature, title: 'Notarised Rent Agreement & NOC', desc: 'We draft your Section 35-compliant Notarised Rent Agreement, NOC and utility bill package ready for GST filing.' },
  { Icon: PackageCheck, title: 'File GST + Add Amazon / Flipkart APOB', desc: 'As an Authorised Partner, we file your PPOB GSTIN and add marketplace APOB in the same registration flow — saving you 15+ days of waiting.' },
];

const ProcessSteps = () => (
  <section className="bg-[#FAF2E8] py-16 md:py-20" data-testid="process-steps">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">The Process</div>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 leading-[1.1]">
          From KYC to APOB in{' '}
          <span className="relative inline-block text-[#F39200]">4 steps
            <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 120 10" fill="none">
              <path d="M2 7 C 40 1, 80 1, 118 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          </span>
        </h2>
        <p className="mt-4 text-[15px] text-neutral-600 max-w-2xl">
          Because we are an <span className="font-semibold text-neutral-900">Authorised Partner</span> of Amazon and Flipkart, we add your APOB alongside GST registration — cutting <span className="font-semibold text-neutral-900">15+ days</span> off the standard timeline.
        </p>
      </div>

      <ol className="mt-10 grid gap-4 md:grid-cols-4 relative">
        <div className="hidden md:block absolute top-6 left-6 right-6 h-px bg-neutral-200" aria-hidden />
        {steps.map((s, idx) => (
          <li key={s.title} className="relative bg-white rounded-2xl border border-black/5 p-5 shadow-sm">
            <div className="flex items-center justify-between">
              <div className="w-12 h-12 rounded-xl bg-[#F39200] text-white flex items-center justify-center font-extrabold shadow-md relative z-10">
                {String(idx + 1).padStart(2, '0')}
              </div>
              <span className="text-[10px] font-semibold uppercase tracking-wider text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-1 rounded-full">
                We do this
              </span>
            </div>
            <div className="mt-4 flex items-start gap-2">
              <s.Icon size={16} className="text-[#F39200] mt-0.5 shrink-0" />
              <div className="text-sm font-semibold text-neutral-900 leading-snug">{s.title}</div>
            </div>
            <p className="mt-2 text-xs text-neutral-600 leading-relaxed">{s.desc}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default ProcessSteps;
